import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import PickupAndDeliveryZone from 'components/Catalog/ProductGrid/CompareModal/Zones/PickupAndDeliveryZone/PickupAndDeliveryZone';
import preferredStoreInfoSelector from 'selectors/user/preferredStoreInfoSelector';
import zipCodeSelector from 'selectors/user/preferredZipCodeSelector';
import storeUtils from 'utils/Store';
import Actions from 'actions/Actions';

const { wrapHOC } = FrameworkUtils;
const { preferredZipCodeSelector } = zipCodeSelector;

const storeNameSelector = createSelector(preferredStoreInfoSelector, preferredStoreInfo => storeUtils.getStoreDisplayName(preferredStoreInfo));

const fields = createStructuredSelector({
    storeName: storeNameSelector,
    zipCode: preferredZipCodeSelector
});

const functions = {
    showStoreSwitcherModal: Actions.showStoreSwitcherModal,
    showShippingDeliveryLocationModal: Actions.showShippingDeliveryLocationModal
};

const withComponentProps = wrapHOC(connect(fields, functions));

export default withComponentProps(PickupAndDeliveryZone);
